<div class="content-wrapper">
  <ng-content></ng-content>
</div>
